"use client";
const defaultRecaptchaConfig = {
    siteKey: "",
    secretKey: "",
    bypassToken: "",
    cookieDomainScript: "",
    minScore: 0.5,
};
let runtimeEnvConfig = {
    recaptcha: defaultRecaptchaConfig,
    isDevelopment: true,
    isProduction: false,
};
export function configureRecaptcha(config) {
    runtimeEnvConfig = {
        recaptcha: {
            ...defaultRecaptchaConfig,
            ...(config.recaptcha ?? {}),
        },
        isDevelopment: config.isDevelopment ?? runtimeEnvConfig.isDevelopment,
        isProduction: config.isProduction ?? runtimeEnvConfig.isProduction,
    };
}
export function getRecaptchaConfig() {
    return runtimeEnvConfig.recaptcha;
}
export function getEnvironmentConfig() {
    return runtimeEnvConfig;
}
export function loadRecaptchaScript() {
    return new Promise((resolve, reject) => {
        const config = getRecaptchaConfig();
        if (!config.siteKey) {
            reject(new Error("reCAPTCHA site key is not configured"));
            return;
        }
        if (typeof window !== "undefined" && window.grecaptcha) {
            resolve();
            return;
        }
        const script = document.createElement("script");
        script.src = `https://www.google.com/recaptcha/api.js?render=${config.siteKey}`;
        script.async = true;
        script.defer = true;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error("Failed to load reCAPTCHA script"));
        document.head.appendChild(script);
    });
}
export async function executeRecaptcha(action) {
    const env = getEnvironmentConfig();
    if (!env.recaptcha.siteKey && env.recaptcha.bypassToken) {
        return env.recaptcha.bypassToken;
    }
    await loadRecaptchaScript();
    if (typeof window !== "undefined" && window.grecaptcha) {
        return new Promise((resolve, reject) => {
            try {
                window.grecaptcha.ready(() => {
                    try {
                        window.grecaptcha
                            .execute(env.recaptcha.siteKey, { action })
                            .then(resolve)
                            .catch(reject);
                    }
                    catch (error) {
                        reject(error);
                    }
                });
            }
            catch (error) {
                reject(error);
            }
        });
    }
    throw new Error("reCAPTCHA is not available");
}
